import { render, staticRenderFns } from "./UserCompanyDetail.vue?vue&type=template&id=2aff830f"
import script from "./UserCompanyDetail.vue?vue&type=script&lang=js"
export * from "./UserCompanyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports